export default __webpack_public_path__ + "f6f569fe66a71fa889cb92d5116094c5.svg";